import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { waLink } from "./data";
import { WhatsAppIcon } from "./WhatsAppIcon";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function ProductCard({ p }) {
  const [open, setOpen] = useState(false);
  const id = slug(p.name);
  return (
    <article
      className="group clip-corner-sm flex flex-col border border-line bg-card transition-colors duration-300 hover:border-edge/60"
      data-testid={`featured-product-${id}`}
    >
      <div className="flex h-44 items-center justify-center bg-[#f2f3f4] p-5">
        <img
          src={p.img}
          alt={`Hercules Fitness ${p.name}`}
          className="max-h-full w-auto object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-edge">{p.type}</p>
        <h4 className="mt-1.5 font-display text-lg font-bold uppercase leading-tight tracking-wide text-white">
          {p.name}
        </h4>
        <AnimatePresence initial={false}>
          {open && (
            <motion.dl
              key="specs"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="mt-4 overflow-hidden"
              data-testid={`featured-specs-panel-${id}`}
            >
              {p.specs.map(([k, v], i) => (
                <div key={`${k}-${i}`} className="flex gap-3 border-t border-line py-1.5 text-[11px] leading-snug">
                  <dt className="w-[45%] shrink-0 font-mono text-[9px] uppercase tracking-[0.08em] text-dim">{k}</dt>
                  <dd className="text-ash">{v || "✓"}</dd>
                </div>
              ))}
            </motion.dl>
          )}
        </AnimatePresence>
        <div className="mt-auto flex items-center gap-2 pt-4">
          <a
            href={waLink(
              `Hi Lift Edge team, I'm interested in the Hercules Fitness ${p.name}. I'm building a gym within a budget — please guide me with the best options.`
            )}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`featured-enquire-${id}`}
            className="clip-corner-sm flex items-center gap-1.5 bg-edge px-3.5 py-2 font-display text-xs font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-edgehot"
          >
            <WhatsAppIcon className="h-3.5 w-3.5" />
            Enquire
          </a>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
            data-testid={`featured-specs-toggle-${id}`}
            className={`flex items-center gap-1 border px-3 py-2 font-mono text-[9px] uppercase tracking-[0.2em] transition-colors duration-200 ${
              open ? "border-white/40 text-white" : "border-line text-ash hover:border-white/40 hover:text-white"
            }`}
          >
            Specs
            <ChevronDown
              size={11}
              className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`}
            />
          </button>
        </div>
      </div>
    </article>
  );
}
